import { baseQueryWithReauth } from './baseQuery';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const rolesApi = createApi({
    reducerPath: 'roles',
    tagTypes: ['Roles', 'FuncionalitiesByProfile'],
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getRoles: builder.query({
            query: (params) => ({
                url: '/roles',
                params
            }),
            providesTags: ['Roles']
        }),
        createRole: builder.mutation({
            query: ({ body }) => ({
                url: `/roles`,
                method: 'POST',
                body
            })
        }),
        getRoleById: builder.query({
            query: (idRol) => ({ url: `roles/${idRol}` }),
            transformResponse: (response: { data: any }) => response?.data
        }),
        editRoleById: builder.mutation({
            query: ({ body, idRol }) => ({
                url: `/roles/${idRol}`,
                method: 'PATCH',
                body
            }),
            invalidatesTags: (_, error) => (error ? [] : ['Roles'])
        }),
        getRolesPerfiles: builder.query({
            query: (params) => ({
                url: '/roles/perfiles',
                params
            }),
            providesTags: ['Roles']
        }),
        getFunctionalities: builder.query({
            query: (params) => ({
                url: 'roles/funcionalidades',
                params: params
            }),
            transformResponse: (response: {
                data: {
                    funcionalidades: any;
                };
            }) => response?.data?.funcionalidades,
            providesTags: ['FuncionalitiesByProfile']
        })
    })
});

export const {
    useGetFunctionalitiesQuery,
    useCreateRoleMutation,
    useGetRolesQuery,
    useLazyGetRolesQuery,
    useLazyGetRoleByIdQuery,
    useEditRoleByIdMutation,
    useGetRolesPerfilesQuery
} = rolesApi;
